// Copyright (c) 2020 Deere & Company

import './parts-coverage-search-report.scss';
import React, {
    Component,
    PropTypes
} from 'react';
import Criteria from '../state/criteria';
import Customer from '@deere/cps-it.warranty-model-factory/lib/customer';
import CustomerPanel from '../../../shared/components/customer-panel/customer-panel';
import FavoriteIcon from '../../../shared/components/favorites/favorite-icon';
import {FormattedMessage} from 'react-intl';
import MeasurementReading from '@deere/cps-it.warranty-model-factory/lib/measurement-reading';
import Modal from '../../../product/shared/state/modal';
import Part from '@deere/cps-it.warranty-model-factory/lib/part';
import PartsCoverageSearch from '@deere/cps-it.warranty-model-factory/lib/parts-coverage-search';
import PartsCoverageSearchCriteria from './parts-coverage-search-criteria';
import PartsCoverageSearchResults from './parts-coverage-search-results';
import PartsCoverageSearchWarrantyDetails from './parts-coverage-search-warranty-details';
import Product from '@deere/cps-it.warranty-model-factory/lib/product';
import ProductInfoPanel from '../../../product/shared/components/product-info-panel/product-info-panel';
import ShowNoResultsFound from '../../shared/components/show-no-results-found/show-no-results-found';
import Warranty from '@deere/cps-it.warranty-model-factory/lib/warranty';
import WarrantyLoadingIndicator from '../../../shared/components/warranty-loading-indicator';

function getPinFromRoute() {

    if (this.queryParams.pin) {

        this.actions.updatePartCoverageSearchCriteria('pin', this.queryParams.pin);

    }

}

function updatePartNumberCriteria(event) {

    const partNumber = event.target.value;

    this.actions.updatePartCoverageSearchCriteria('partNumber', partNumber);

}

function updatePinCriteria(event) {

    const pin = event.target.value;

    this.actions.updatePartCoverageSearchCriteria('pin', pin);

}

function updateCurrentMachineHoursCriteria(currentMachineHours) {

    this.actions.updatePartCoverageSearchCriteria('currentMachineHours', currentMachineHours);

}

function handleCreatePartCoverageSearchReport() {

    this.actions.fetchPartCoverageSearch({currentMachineHours: this.criteria.currentMachineHours, partNumber: this.criteria.partNumber, pin: this.criteria.pin});

}

function resetPartSearchCriteria() {

    this.actions.resetPartCoverageSearch();
    this.actions.updateShowNoResultsFound(false);

}

function handleStatusChangeModalVisibility(value) {

    this.actions.updateStatusChangeModalVisibility(value);

}

function handleAmountOfUseModalClose() {

    this.actions.updateAmountOfUseModalVisibility(false);

}

function handleAmountOfUseModalOpen() {

    this.actions.updateAmountOfUseModalVisibility(true);

}

function handleUpdateStatus() {

    this.actions.updateStatusChangeModalVisibility(false);
    this.actions.goToStatusChangeRequestView(this.product.pin);

}

function handleSubmitOnEnterKeyPress() {

    if (event.key === 'Enter' && this.criteria.partNumber !== '') {

        this::handleCreatePartCoverageSearchReport();

    }

}

class PartsCoverageSearchReport extends Component {

    componentWillMount() {

        this.props::getPinFromRoute();

    }

    componentWillUnmount() {

        this.props.actions.resetPartCoverageSearch();
        this.props.actions.updateShowNoResultsFound(false);

    }

    render() {

        return (
            <div>
                <section className='part-coverage-search'>
                    <h2 className='part-coverage-search-title'>
                        <FormattedMessage id='PARTS_COVERAGE_SEARCH'/>
                        <FavoriteIcon
                            id='PARTS_COVERAGE_SEARCH'
                            route={this.props.pathName}
                        />
                    </h2>

                    <PartsCoverageSearchCriteria
                        criteria={this.props.criteria}
                        handleCurrentMachineHoursChange={this.props::updateCurrentMachineHoursCriteria}
                        handlePartNumberChange={this.props::updatePartNumberCriteria}
                        handlePinChange={this.props::updatePinCriteria}
                        handleSubmitOnEnterKeyPress={this.props::handleSubmitOnEnterKeyPress}
                        onCreatePartCoverageSearchReport={this.props::handleCreatePartCoverageSearchReport}
                        onCriteriaReset={this.props::resetPartSearchCriteria}
                    />

                    <WarrantyLoadingIndicator isLoading={this.props.busyCounter > 0}/>
                    {this.props.report.length && this.props.part ?
                        <div>
                            <div className='help-text'>
                                <FormattedMessage id='ALL_CLAIMS_ARE_SUBJECT_TO_REVIEW'/>
                            </div>
                            <PartsCoverageSearchResults
                                part={this.props.part}
                                report={this.props.report}
                                warranties={this.props.warranties}
                            />
                        </div> :
                        <ShowNoResultsFound showNoResultsFound={this.props.showNoResultsFound}/>
                    }
                    {
                        this.props.pin !== '' &&
                            <div className='part-coverage-search-title'>
                                <h2>{this.props.pin}</h2>
                            </div>
                    }

                    {this.props.product.pin !== '' &&
                        <div className='parts-coverage-details'>
                            <main>
                                <ProductInfoPanel
                                    changeModalVisibility={this.props::handleStatusChangeModalVisibility}
                                    isAmountOfUseModalOpen={this.props.isAmountOfUseModalOpen}
                                    measurementReadings={this.props.measurementReadings}
                                    onAmountOfUseModalClose={this.props::handleAmountOfUseModalClose}
                                    onAmountOfUseModalOpen={this.props::handleAmountOfUseModalOpen}
                                    product={this.props.product}
                                    productStatusChangeModal={this.props.partsCoverageSearchStatusChangeModal}
                                    updateStatus={this.props::handleUpdateStatus}
                                />
                                <PartsCoverageSearchWarrantyDetails
                                    pin={''}
                                    warranties={this.props.warranties}
                                />
                            </main>
                            <aside>
                                <CustomerPanel
                                    customer={this.props.customer}
                                    product={this.props.product}
                                />
                            </aside>
                        </div>
                    }
                </section>

            </div>
        );

    }

}

PartsCoverageSearchReport.displayName = 'PartsCoverageSearchReport';
PartsCoverageSearchReport.propTypes = {
    actions: PropTypes.object.isRequired,
    busyCounter: PropTypes.number.isRequired,
    criteria: PropTypes.instanceOf(Criteria).isRequired,
    customer: PropTypes.instanceOf(Customer).isRequired,
    isAmountOfUseModalOpen: PropTypes.bool.isRequired,
    measurementReadings: PropTypes.arrayOf(PropTypes.instanceOf(MeasurementReading)).isRequired,
    part: PropTypes.instanceOf(Part).isRequired,
    partsCoverageSearchStatusChangeModal: PropTypes.instanceOf(Modal).isRequired,
    pathName: PropTypes.string.isRequired,
    pin: PropTypes.string.isRequired,
    product: PropTypes.instanceOf(Product).isRequired,
    report: PropTypes.arrayOf(PropTypes.instanceOf(PartsCoverageSearch)),
    showNoResultsFound: PropTypes.bool.isRequired,
    warranties: PropTypes.arrayOf(PropTypes.instanceOf(Warranty)).isRequired
};

export default PartsCoverageSearchReport;



// WEBPACK FOOTER //
// ./src/reports/parts-coverage-search/components/parts-coverage-search-report.js